import { loadRemoteScript } from "@/utils/scriptLoader";

/**
 * 抖店前端日志 暂时仅接入抖店 , 千牛等过滤掉
 */
export function initDDJsLog() {
    console.log("接入抖店js日志...");

    loadRemoteScript("https://lf3-static.bytednsdoc.com/obj/eden-cn/abueh7pldnuhog/monitor.js?bid=6838416245163820552");
}
